import { OrderItem, OrderMenuSet } from 'earn-ts/build/rust';
import { groupBy, map } from 'lodash';
import { useAppSelector } from 'src/app/store';
import { IViewMenuItem } from 'src/reducer/order/types';
import { formatCents, pickName } from 'src/utils';
import { twMerge } from 'tailwind-merge';        

interface IProps {
  item: OrderMenuSet;
  lang: string;
  classNames?: string
}

const MenuSetItemOrder: React.FC<IProps> = ({ item, lang, classNames }) => {
  const { menus, foods, priceMenus, menuDef } = useAppSelector(
    state => state.order,
  );
  const { id, menuset_id, sections, quantity } = item;

  const getNameMenuById = (menuId: string) => {
    return pickName(menus[menuId], lang) ?? '';
  };
  const getNameFoodById = (foodId: string) => {
    return pickName(foods[foodId], lang) ?? '';
  };
  const getOptionName = (groupId: string, optionId: string) => {
    return pickName(menuDef!.option_groups[groupId].op[optionId], lang) ?? '';
  };

  const getMenuView = (items: OrderItem[]): IViewMenuItem[] => {
    const groupedItems = groupBy(items, item =>
      JSON.stringify({ food_id: item.food_id, options: item.options }),
    );

    return map(groupedItems, group => ({
      ...group[0],
      quantity: group.length ?? 1,
    }));
  };

  const displayOptionPriceAdd = (groupId: string, optionId: string) => {
    const priceAdd = menuDef?.option_groups[groupId].op[optionId].price_add;
    return priceAdd ? `(+${formatCents(priceAdd)})` : '';
  };

  return (
    <div className={twMerge("w-full px-[15px] text-[16px]", classNames)}>
      <div className="flex flex-row justify-between font-medium mb-2">
        <div>
          {quantity} x{' '}
          <span className="capitalize">{getNameMenuById(menuset_id)}</span>
        </div>
        <div>{formatCents(priceMenus[id] ?? 0)}</div>
      </div>
      {Object.keys(sections || {})?.map((sectionId: any, index: any) => (
        <div
          className="flex flex-col mt-1 font-normal text-shadow-5"
          key={index}>
          {getMenuView(sections[sectionId])?.map(
            (foodItem: any, index: any) => (
              <div key={index}>
                <div>
                  {`${foodItem.quantity} x `}
                  <span className="text-left capitalize">
                    {getNameFoodById(foodItem.food_id)}
                  </span>
                </div>
                <ul className="list-disc text-left">
                  {Object.keys(foodItem.options || {})?.map(
                    (optionGroup: any, index: any) => (
                      <li className="ml-8" key={index}>
                        <div className="flex flew-row">
                          <div className="capitalize">
                            {`${optionGroup}: `}&nbsp;
                          </div>
                          <div className="flex flex-row items-center">
                            {foodItem?.options[optionGroup].flags?.map(
                              (item: any, index: any) => (
                                <div className="capitalize" key={index}>
                                  {' '}
                                  {`${getOptionName(optionGroup, item)} `}
                                  {displayOptionPriceAdd(optionGroup, item)}
                                </div>
                              ),
                            )}
                          </div>
                        </div>
                      </li>
                    ),
                  )}
                </ul>
              </div>
            ),
          )}
        </div>
      ))}
    </div>
  );
};

export default MenuSetItemOrder;
